var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"date-time"},[_vm._v("dd/mm/yyyy hh:mm:ss PM")])}
var staticRenderFns = []

export { render, staticRenderFns }